import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import InfoPage from '../../InfoPage';

export default function Careers() {
  const { t } = useTranslation();
  const departments = t('careers.departments', { returnObjects: true }) || [];
  return (
    <InfoPage
      eyebrow={t('info.company')}
      title={t('careers.title')}
      subtitle={t('careers.subtitle')}
    >
      <h2>{t('careers.whereWereGrowing')}</h2>
      <div className="info-grid">
        {departments.map((d) => (
          <div key={d.name} className="info-card">
            <h3>{d.name}</h3>
            <p>{d.desc}</p>
          </div>
        ))}
      </div>

      <h2>{t('careers.applyingToDrive')}</h2>
      <p>
        {t('careers.driveCopyBefore')} <Link to="/drive">{t('careers.driveLink')}</Link> {t('careers.driveCopyAfter')}
      </p>

      <h2>{t('careers.everythingElse')}</h2>
      <p>
        {t('careers.everythingElseCopyBefore')}{' '}
        <a href="mailto:careers@starviewcinema.com">careers@starviewcinema.com</a>
        {t('careers.everythingElseCopyAfter')}
      </p>
    </InfoPage>
  );
}
